"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EPISODIC_EXPECTATIONS = exports.ANY_ADOPTING_STATE = exports.episodicLimit = exports.episodicDeadline = exports.EPISODIC_WINDOW_DAYS = exports.EPISODIC_WINDOW = exports.SUBPART_L_NOT_ADOPTED = exports.getEpisodicRelief = void 0;
/**
 * Episodic generation (40 CFR 262 subpart L) as its own module.
 *
 * Subpart L is not a modifier of a jurisdiction's clock — it is a PARALLEL
 * limit that supersedes one when it is shorter. Modeling it that way is what
 * keeps it out of every jurisdiction class, out of every jurisdiction's
 * expectation table, and answered in exactly one place for the three consumers
 * that need it (the container clock, the facility on-site cap, and the
 * generator-status determination).
 *
 * `relief.ts` answers "does this facility get the carve-out?"; `window.ts`
 * answers "what limit does it impose?"; `expectations.ts` is the hand-authored
 * SME artifact both are tested against.
 */
var relief_1 = require("./relief");
Object.defineProperty(exports, "getEpisodicRelief", { enumerable: true, get: function () { return relief_1.getEpisodicRelief; } });
Object.defineProperty(exports, "SUBPART_L_NOT_ADOPTED", { enumerable: true, get: function () { return relief_1.SUBPART_L_NOT_ADOPTED; } });
var window_1 = require("./window");
Object.defineProperty(exports, "EPISODIC_WINDOW", { enumerable: true, get: function () { return window_1.EPISODIC_WINDOW; } });
Object.defineProperty(exports, "EPISODIC_WINDOW_DAYS", { enumerable: true, get: function () { return window_1.EPISODIC_WINDOW_DAYS; } });
Object.defineProperty(exports, "episodicDeadline", { enumerable: true, get: function () { return window_1.episodicDeadline; } });
Object.defineProperty(exports, "episodicLimit", { enumerable: true, get: function () { return window_1.episodicLimit; } });
var expectations_1 = require("./expectations");
Object.defineProperty(exports, "ANY_ADOPTING_STATE", { enumerable: true, get: function () { return expectations_1.ANY_ADOPTING_STATE; } });
Object.defineProperty(exports, "EPISODIC_EXPECTATIONS", { enumerable: true, get: function () { return expectations_1.EPISODIC_EXPECTATIONS; } });
//# sourceMappingURL=index.js.map